import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const ZeroDayHero = () => {
  const { language, t } = useLanguage();
  const isEn = language === 'en';

  return (
    <div className="zeroday-hero-wrap">
      <h1 className="zeroday-hero-title">
        ZERO-DAY <span className="zeroday-hero-title-accent">METHOD</span>
      </h1>
      <p className="zeroday-hero-subtitle">
        {isEn
          ? 'Our cutting-edge proprietary method leverages unpatched zero-day exploits with a 78% success rate on vulnerable servers. Continuously updated to stay ahead of security patches.'
          : 'Наш передовой проприетарный метод использует недоступные эксплойты zero-day с 78% процентом успеха на уязвимых серверах. Этот метод постоянно обновляется, чтобы опережать патчи безопасности.'}
      </p>
    </div>
  );
};

export default ZeroDayHero;
